export default class DeviceData {
  name?: string | null;
  code?: string | null;
}
